import React, { useContext } from "react";

import { DataContext } from "../../../../../../providers/GasCheckoutDataProvider";
import errorMessages from "../../../../../../utils/validation/errorMessages";
import FormError from "../../../../../shared/forms/FormError";
import NewInput from "../../../../../shared/forms/NewInput";
import NewHeadline from "../../../../../shared/NewHeadline";

const Amount = () => {
    const dataContext = useContext(DataContext);
    const { consumption } = dataContext.data;
    const { setConsumption, hasFormErrorAt, addFormError, clearFormError } =
        dataContext.actions;

    /**
     * When the amount changes.
     *
     * @param {*} event
     */
    const onChangeAmount = (event) => {
        setConsumption(event.target.value);
    };

    return (
        <React.Fragment>
            <NewHeadline>Bedarf:</NewHeadline>
            <NewInput
                type="text"
                placeholder="Menge"
                name="consumption"
                onChange={onChangeAmount}
                value={consumption}
                validation="consumption"
                forceError={hasFormErrorAt("consumption")}
                onError={() => addFormError("consumption")}
                onErrorSolved={() => {
                    clearFormError("consumption");
                }}
                withField
            />
            {hasFormErrorAt("consumption") && (
                <FormError
                    className="is-light"
                    message={errorMessages.consumption}
                />
            )}
        </React.Fragment>
    );
};

export default Amount;
